export const customStyle = {
  strokeLinecap: 'round',
  textSize: '22px',
  pathTransitionDuration: 0.5,
  pathColor: `#69D8E3`,
  textColor: 'black',
  trailColor: '#B5B5B5',
  backgroundColor: 'white',
};
